import { render, staticRenderFns } from "./DetalheHistoricoInadimplenciaForm.vue?vue&type=template&id=64fa28d0&scoped=true&"
import script from "./DetalheHistoricoInadimplenciaForm.vue?vue&type=script&lang=js&"
export * from "./DetalheHistoricoInadimplenciaForm.vue?vue&type=script&lang=js&"
import style0 from "./DetalheHistoricoInadimplenciaForm.vue?vue&type=style&index=0&id=64fa28d0&scoped=true&lang=css&"
import style1 from "./DetalheHistoricoInadimplenciaForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa28d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
